import { useGetOne, useStore } from 'react-admin';
import type { PartnerSettings } from '@src/settings';
import type { Partner } from '@src/types';

/**
 * Whether the currently selected partner has an active Looker service
 * (a lookerServiceConfig setting mapping them to a Looker service id +
 * client credentials).
 */
export const useLookerActive = (): boolean => {
  const [currentPartner] = useStore<Partner | null>('currentPartner', null);
  const { data: settings } = useGetOne<PartnerSettings & { id: number }>(
    'settings',
    { id: 0 },
    { enabled: Boolean(currentPartner) }
  );
  return Boolean(settings?.lookerServiceConfigured);
};
